<div *ngIf="versionCheckWorkerService.updateAvailable$ | async" class="new-version-update-notification">
	<p>Nouvelle version disponible. Charger la nouvelle version ?</p>
	<button (click)="reloadPage()">Charger</button>
</div>
